import { Box, Divider, Grid, Link, Typography } from "@mui/material";
import { ResponsiveTableProps } from ".";
import LabelPrinter from "../../../../components/LabelPrinter";
import SituacaoProcessoChip from "../../../../components/SituacaoProcessoChip";
import moment from "moment";

export default function MobileTable({
    processos,
    handleOpenModalDetail
}: ResponsiveTableProps) {

    return (
        <>
            {processos.map((row: any, index: number) => (
                <Box key={index}>
                    <Divider />
                    <Box
                        p={2}
                    >
                        <Grid container spacing={2}>
                            <Grid size={{xs: 4}}>
                                <Link onClick={() => handleOpenModalDetail(row.codigo)} component="div" fontSize={13} sx={{ cursor: 'pointer' }}>#{row.codigo}</Link>
                                <Typography variant='caption'>{moment(row.created_at).format('DD/MM/YYYY HH:mm')}</Typography>
                            </Grid>

                            <Grid size={{xs: 8}}>
                                <LabelPrinter
                                    titulo="Criado por"
                                    valor={`${row.usuario} - ${row.perfil}`}
                                    size='small'
                                />
                            </Grid>

                            <Grid size={{xs: 4}}>
                                <SituacaoProcessoChip situacao={row.situacao} />
                            </Grid>

                            <Grid size={{xs: 8}}>
                                <LabelPrinter
                                    titulo="Tarefa em andamento"
                                    valor={row.tarefa_atual.titulo}
                                    size='small'
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            ))}
        </>
    )
}